<div class="modal-dialog" role="document">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				data-dismiss="modal" type="button">Chiudi</button>
		</p>
		<div class="col-sm-12 coldx">
			<h4>Riunisci giudizi</h4>
			<ng-template [ngIf]="pratica && fascicolo">
			<div class="row">
				<fieldset class="form-group">
					<legend>Dati del capofila</legend>
					<ul  class="pratiche">
						<li class="panel">
							<div
								class="{{'pratica ' + getClassPratica(pratica.tipoPratica.id)}}">
								<div>
									<p
										[className]="'categoria '+getClassPratica(pratica.tipoPratica.id)">{{pratica.intestazione.campi.tipoPratica | tipoPraticaPipe}}</p>
									<p class="codice">{{pratica.intestazione.campi.posizionePratica}}</p>
								</div>
								<div>
									<p class="identificativo">
										{{(pratica.intestazione?.campi?.dataAperturaPratica ?
											(' DEL ' + (pratica.intestazione?.campi?.dataAperturaPratica |
											date:'dd/MM/yyyy')) : (pratica.intestazione?.campi?.dataApertura ?
											(' DEL ' + (pratica.intestazione?.campi?.dataApertura |  date:'dd/MM/yyyy')) : ''))
										}}{{ pratica.intestazione.campi.definita == 'true' ? (' DEFINITA IL ' + (pratica.dataDefinizione | date:'dd/MM/yyyy')) : '' }}&nbsp;
										<span
											*ngIf="pratica.definito" title="Definita"
											class="glyphicon glyphicon-lock"></span> <span
											*ngIf="pratica.correlata" title="Correlata"
											class="glyphicon glyphicon-link"></span> <span
											*ngIf="pratica.capofila" title="Capofila riunione di giudizi"
											class="riunionegiudizi glyphicon glyphicon-resize-small"><span
											class="glyphicon capofila">C</span></span> <span
											*ngIf="pratica.riunita" title="Riunione di giudizi"
											class="glyphicon glyphicon-resize-small"></span> <span
											*ngIf="pratica.archiviata" title="Archiviata"
											class="glyphicon glyphicon-floppy-saved"></span>
									</p>
									<h4 class="titolo">
										{{pratica.intestazione.campi.contropartePrimaria ?
										pratica.intestazione.campi.contropartePrimaria + " - " :
										"Nessun soggetto/parte specificato " + " - " }} {{
										pratica.intestazione.campi.materia ?
										pratica.intestazione.campi.materia + "/" : ""}} {{
										pratica.intestazione.campi.oggetto ?
										pratica.intestazione.campi.oggetto : "" }}</h4>
								</div>
							</div>
							<ul class="collapse in" id="subpratica3" aria-expanded="true"
								style="">
								<li>
									<div
										class="{{'subpratica ' +getCssClassCategoriaFascicolo (fascicolo)}}">
										<div>
											<p
												class="{{'categoria ' + fascicolo.intestazione.campi.tipoFascicolo.toLowerCase()}}">{{
												fascicolo.intestazione.campi.tipoFascicolo}}</p>
											<p class="codice">{{
												fascicolo.intestazione.campi.posizione }}</p>
										</div>
										<div>
											<p class="identificativo">
												{{fascicolo?.intestazione.campi.numeroRuolo ? 'N. ruolo' :''}}
												<strong>{{fascicolo?.intestazione.campi.numeroRuolo ?	fascicolo?.intestazione.campi.numeroRuolo+' ' :''}} </strong>
												{{fascicolo?.intestazione.campi.annoRuolo && fascicolo?.intestazione.campi.numeroRuolo ? '-' :''}}
												{{fascicolo?.intestazione.campi.annoRuolo ? 'A. ruolo' :''}}
												<strong>{{fascicolo?.intestazione.campi.annoRuolo ?	fascicolo?.intestazione.campi.annoRuolo+' ' :' '}} </strong>
												{{ fascicolo?.intestazione.campi.annoRuolo || fascicolo?.intestazione.campi.numeroRuolo ? '&nbsp;' : '' }}
												{{ 'DEL' + (fascicolo.intestazione.campi.dataInizioFascicolo |	date:'dd/MM/yyyy') }}
												{{fascicolo.intestazione.campi.definito ? ' - DEFINITA IL ' +
												(fascicolo.intestazione.campi.dataDefinizione |
												date:'dd/MM/yyyy') : '' }} &nbsp;
												{{(fascicolo.intestazione.campi.tipoRicorso) ? (' - '+fascicolo.intestazione.campi.tipoRicorso) : ''}} &nbsp;
												{{(fascicolo.intestazione.campi.tipoOpposizione) ? (' - '+fascicolo.intestazione.campi.tipoOpposizione) : ''}}<span
													*ngIf="fascicolo.intestazione.campi.definito"
													title="Definito" class="glyphicon glyphicon-lock"></span> <span
													*ngIf="fascicolo.intestazione.campi.capofila"
													title="Capofila riunione di giudizi"
													class="riunionegiudizi glyphicon glyphicon-resize-small"><span
													class="glyphicon capofila">C</span></span> <span
													*ngIf="fascicolo.intestazione.campi.riunito"
													title="Riunione di giudizi"
													class="glyphicon glyphicon-resize-small"></span> <span
													*ngIf="pratica.archiviata" title="Archiviato"
													class="glyphicon glyphicon-floppy-saved"></span>
													<span *ngIf="fascicolo.intestazione.campi.isDocumentazione" class="glyphicon glyphicon-file" title="Documenti allegati"></span>
											</p>
											<h5 class="titolo">
												{{fascicolo.intestazione.campi.contropartePrimaria ?
												fascicolo.intestazione.campi.contropartePrimaria :
												"Nessun soggetto/parte specificato " }}
												<ng-container> {{
													fascicolo.intestazione.campi.grado ?
													   " - " + fascicolo.intestazione.campi.grado : "" }}
												</ng-container>
												{{fascicolo?.intestazione.campi.natura ? " - " +
                          						fascicolo?.intestazione.campi.natura : ""}}
											</h5>
										</div>
									</div>
								</li>
							</ul>
						</li>
					</ul>

				</fieldset>
			</div>
			<ng-template [ngIf]="searchForm">
			<form [formGroup]="searchForm" (ngSubmit)="searchPratiche();">
				<div class="row">
					<div class="col-sm-6">
						<p>
							<label for="autorita_giud_lbl">Autorit&agrave; giudiziaria</label> <select
								id="autorita_giud_lbl" class="form-control" disabled>
								<option selected value="{{ fascicolo.autoritaGiudiziaria?.id }}">{{
									fascicolo.autoritaGiudiziaria?.label }}</option>
							</select>
						</p>
					</div>
					<div class="col-sm-6">
						<p>
							<label for="comune_lbl">Comune</label> <select id="comune_lbl" class="form-control" disabled>
								<option selected
									value="{{ fascicolo.autoritaGiudiziariaCitta?.id }}">{{
									fascicolo.autoritaGiudiziariaCitta?.label }}</option>
							</select>
						</p>
					</div>
				</div>
				<div class="row">
					<div comboModInput class="col-sm-6"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.tipoPratica"
						[labelInput]="'Tipo Pratica'" formControlName="tipoPratica"
						[optionsCombo] ="tipiPratica" [labelOption]="'descrizione'"
						[objectReference]="requestSearchRiunisci.searchCriteria.tipoPratica"
						(onReturn)="onSelectTipoPratica($event)"></div>
					<div comboModInput class="col-sm-6" [isSearchRequest]="true"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['tipoFascicolo']"
						[labelInput]="'Tipo Fascicolo'" formControlName="tipoFascicolo"
						[optionsCombo] ="tipiFascicolo"
						[objectReference]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['tipoFascicolo']"
						(onReturn)="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['tipoFascicolo'].value = ($event !== null) ? $event.id : $event"></div>
				</div>
				<div class="row">
					<div comboModInput class="col-sm-6" [isSearchRequest]="true"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['materia']"
						[labelInput]="'Materia'" formControlName="materia"
						[optionsCombo] ="materiaOptions"
						[objectReference]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['materia']"
						(onReturn)="onSelectMateria($event)"></div>
					<div comboModInput class="col-sm-6" [isSearchRequest]="true"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['oggetto']"
						[labelInput]="'Oggetto'" formControlName="oggetto"
						[optionsCombo] ="oggettoOptions"
						[objectReference]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['oggetto']"
						(onReturn)="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['oggetto'].value = ($event !== null) ? $event.id : $event"></div>
				</div>
				<div class="row">
					<div textInput class="col-sm-6" [labelInput]="'Giudice'"
						formControlName="giudice"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['giudice'].value"></div>
					<div datePickerInput class="col-sm-6" [labelInput]="'Data udienza'"
						formControlName="dataUdienza"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['dataUdienza'].value"></div>
				</div>
				<div class="row">
					<div datePickerInput class="col-sm-6"
						[labelInput]="'Data apertura fascicolo dal'"
						formControlName="dataInizioFascicoloDal"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.inizioFascicoloDataDa"></div>
					<div datePickerInput class="col-sm-6"
						[labelInput]="'Data apertura fascicolo al'"
						formControlName="dataInizioFascicoloAl"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.inizioFascicoloDataA"></div>
				</div>
				<div class="row">
					<div textInput class="col-sm-12" [labelInput]="'Nome parte'"
						formControlName="nomeControparte"
						[(ngModel)]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['nomeControparte'].value">
					</div>
          <p class="col-sm-12">
            <label for="cognome_controparti_lbl">Cognome controparti</label>
            <input id="cognome_controparti_lbl" type="text" class="form-control" placeholder="Inserisci cognome" autocomplete="family-name" formControlName="cognomeControparte"
                   [(ngModel)]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['cognomeControparte'].value">
          </p>

          <p class="col-sm-12">
            <label for="pos-prat-lbl">Posizione pratica</label>
            <input id="pos-prat-lbl" type="text" class="form-control" placeholder="Inserisci posizione" formControlName="posizione"
                   [(ngModel)]="requestSearchRiunisci.searchCriteria.posizionePratica">
          </p>

          <p class="col-sm-12">
            <label for="n-ruolo-lbl">N. ruolo</label>
            <input id="n-ruolo-lbl" type="text" class="form-control" placeholder="Inserisci n. ruolo" formControlName="numeroRuolo"
                   [(ngModel)]="requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].value">
          </p>
				</div>
				<div class="row">
					<p class="col-sm-9">{{ msgRicercaEmpty }}</p>
					<p submitButton class="col-sm-3" [labelButton]="'Cerca pratiche'">
				</div>
			</form>
			</ng-template> <ng-template
				[ngIf]="riunioneGiudiziForm && listFascicoliFromSearch.length > 0">
			<form [formGroup]="riunioneGiudiziForm"
				(ngSubmit)="riunisciGiudizi();">

				<div class="container_dati_generali container_overflow">
					<ul  class="pratiche firstlevel">
						<li class="panel"
							*ngFor="let fascicolo of listFascicoliFromSearch; let j = index">
							<ul class="collapse in" id="capofilagiudizi" aria-expanded="true">
								<li>
									<div
										class="{{'subpratica ' +getCssClassCategoriaFascicoloLight (fascicolo)}}">
										<div>
											<p
												class="{{'categoria ' + fascicolo.intestazione.campi.tipoFascicolo.toLowerCase()}}">{{fascicolo.intestazione.campi.tipoFascicolo}}</p>
											<p class="codice">{{
												fascicolo.intestazione.campi.posizione }}</p>
										</div>
										<div class="data_opzioni blocco_pratica">
											<p class="singlecheckbox active">
												<ng-template [ngIf]="!fascicolo.intestazione.campi.riunito">
													<input name="{{'riuniscifascicolo'+j}}"
													id="{{'riuniscifascicolo'+j}}" [value]="fascicolo.id"
													(click)="onCheckFascicolo($event, fascicolo)" type="checkbox">
												</ng-template>
												<ng-template [ngIf]="fascicolo.intestazione.campi.riunito">
													<input name="{{'riuniscifascicolo'+j}}"
													id="{{'riuniscifascicolo'+j}}" [value]="fascicolo.id"
													(click)="onCheckFascicolo($event, fascicolo)" type="checkbox" disabled>
												</ng-template>
												<label for="{{'riuniscifascicolo'+j}}"></label>
											</p>
										</div>
										<div>
											<p class="identificativo">{{fascicolo.intestazione.campi.numeroRuolo
												? 'N. ruolo '+fascicolo.intestazione.campi.numeroRuolo+' ' :
												''}}{{ 'DEL ' +
												(fascicolo.intestazione.campi.dataInizioFascicolo |
												date:'dd/MM/yyyy') }}
												{{fascicolo.intestazione.campi.definito ? ' - DEFINITA IL '
												+ (fascicolo.intestazione.campi.dataDefinizione |
												date:'dd/MM/yyyy') : '' }}</p>
											<h5 class="titolo">{{fascicolo.intestazione.campi.contropartePrimaria
												? fascicolo.intestazione.campi.contropartePrimaria :
												"Nessun soggetto/parte specificato " }}
                      </h5>
										</div>
									</div>
								</li>
							</ul>
						</li>
					</ul>
				</div>
				<div class="standardpanel">
					<div class="row">
						<p *ngIf="praticheTotali > listPraticheFromSearch.length"
							class="allinea_centro col-sm-12">
							<a href="javascript:void(0);" (click)="reloadSearch()"> <strong>Carica
									altri risultati</strong></a>
						</p>
						<p *ngIf="praticheTotali <= listPraticheFromSearch.length"
							class="allinea_centro col-sm-12">
							<strong>Non ci sono altri risultati</strong>
						</p>
					</div>
				</div>
				<div class="row container_fieldset">
					<fieldset class="form-group">
						<legend>Riunisci i giudizi delle pratiche selezionate</legend>

						<div datePickerInput class="form-group col-sm-12"
							[mandatory]="true" [labelInput]="'Data riunione'"
							formControlName="dataRiunione"
							[(ngModel)]="requestRiunione.dataRiunione"></div>

						<div textAreaInput class="form-group col-sm-12"
							[labelInput]="'Motivo riunione'" [mandatory]="true"
							formControlName="motivoRiunione"
							[(ngModel)]="requestRiunione.motivoRiunione"></div>
					</fieldset>
				</div>
				<div class="row">
					<p class="col-md-12 mandatory">
						<em>* Campi obbligatori - deve essere selezionato almeno un
							fascicolo </em>
					</p>
				</div>
				<div class="row">
					<div class="col-xs-6 visible-xs"></div>
					<p
						submitButton [disabled] = "!requestRiunione.dataRiunione || !requestRiunione.motivoRiunione"
						 [submitPending]="requestRiunione.fascicoliDaRiunire.length == 0"
						class="col-sm-3 col-xs-6 col-sm-offset-9"
						[labelButton]="'Riunisci giudizi'">
				</div>
			</form>
			</ng-template> </ng-template>
		</div>
	</div>
</div>
